import React from 'react';
import styles from './CompactList.module.css';

export default function CompactListV1<T>({
  blockData,
  titleSuffix,
  titlePrefix
}: any) {
  return (
    <div
      className={`${styles.linkBoxWrap__DetailsBlock} appendRight10 appendBottom30`}
    >
      <h2
        className={`${styles.linkBoxWrap__Details__title} desktopShow font22 latoBold appendBottom15 `}
      >
        {titlePrefix + titleSuffix}
      </h2>
      <div className={`${styles.linkBoxWrap__about}`}>
        <h2
          style={{ display: 'none' }} // disabled in SSR HTML
          className="mobileShow paddingR16 paddingT15 paddingB10 appendBottom5"
        >
          <span
            style={{ display: 'block' }}
            className={'font22 latoLight appendBottom2 paddingL16'}
          >
            {titlePrefix}
          </span>
          <span className={'font16 latoBold lineHeight20 blackText paddingL16'}>
            {titleSuffix}
          </span>
        </h2>
        <ul className={`${styles.linkBoxWrap__List}`}>
          {blockData.map((item, idx) => {
            const itemName = item?.name ?? item?.sourceCityName ?? item;
            return (
              <li
                key={`${itemName}_${idx}`}
                className={`${idx ? `paddingT10 paddingB10` : `paddingB10`} ${
                  styles.linkBoxWrap__StripedList__li
                } `}
              >
                {item.url ? (
                  <a key={idx} href={item.url} className="linkBoxFont">
                    {itemName}
                  </a>
                ) : (
                  <span>{itemName}</span>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
